import header from "./happy-senior-hold-key.jpg";
import section1 from "./aerial-view-private-houses.jpg";
import section2 from "./grandparents-learning-use-digital-device.jpg";
import section3 from "./close-up-woman-with-calculator.jpg";
import section4 from "./makler-zeigt-die-wohnung.webp";
import section5 from "./grandparent-sitting-by-window.jpg";

export { header, section1, section2, section3, section4, section5 };
